angular.module("delegaAttivita.components", []).component("delegaAttivita", {
    templateUrl: "ng/components/delegaAttivita/delegaAttivita.view.html",
    controllerAs: "delegaAttivitaCtrl",
    controller: function (
        $financialApiService,
        $rootScope,
        $location,
        $timeout
    ) {
        var self = this;


        self.$onInit = function () {
            self.permissions = JSON.parse(window.sessionStorage.getItem('alba-appConfig'));
            self.supportModel = {
                listaAssegnatari: undefined,
                assegnatarioSelezionato: undefined,
                dataDa: undefined,
                dataA: undefined,
                confirmEnabled: false,
                assigneeNdg: undefined,
                nameAndSurname: undefined,
                name: undefined,
                surname: undefined
            }

            self.permissions.allFunctionalities.forEach(function (item) {
                if (item === 'INTERNAL_TEAM_LEADER' || item == 'INSERISCI_DELEGA') {
                    self.getDelega();
                    self.getAssegnatari();
                }
            })
        }

        self.getAssegnatari = function () {
            $financialApiService.getAssegnatari()
                .then(function (response) {
                    self.supportModel.listaAssegnatari = response;

                    response.forEach(function (assegnatario) {
                        if (assegnatario.ndg === self.supportModel.assigneeNdg) {
                            self.supportModel.assegnatarioSelezionato = assegnatario;
                        }
                    })
                })
        }

        self.getDelega = function () {
            $financialApiService.getDelega()
                .then(function (response) {
                    self.supportModel.assigneeNdg = response.assigneeNdg;

                    if (response.dateFrom) {
                        self.supportModel.dataDa = moment(response.dateFrom).format("DD/MM/YYYY");
                    }

                    if (response.dateTo) {
                        self.supportModel.dataA = moment(response.dateTo).format("DD/MM/YYYY");
                    }
                })
        }

        self.handleChange = function (property) {
            if (self.supportModel.assegnatarioSelezionato &&
                self.supportModel.dataDa &&
                self.supportModel.dataA) {
                self.confirmEnabled = true;
            } else {
                self.confirmEnabled = false;
            }
        }

        self.conferma = function () {
            var dateFromTime = moment(self.supportModel.dataDa, "DD/MM/YYYY").toDate().getTime();
            var dateToTime = moment(self.supportModel.dataA, "DD/MM/YYYY").toDate().getTime();

            $financialApiService.setDelega(
                self.supportModel.assegnatarioSelezionato.ndg,
                dateFromTime,
                dateToTime,
                self.supportModel.assegnatarioSelezionato.nome,
                self.supportModel.assegnatarioSelezionato.cognome
            )
                .then(function () {
                    $rootScope.$broadcast("addAlert", {
                        text: "DELEGA_ATTIVITA"
                    });
                })
        }

        self.elimina = function () {
            $financialApiService.removeDelega()
                .then(function () {
                    self.resetDelega();
                })
        }

        self.chiudi = function () {
            closeDelegaAttivita();

            $timeout(function () {
                $location.path('/');
            }, 500);
        }

        self.resetDelega = function () {
            self.supportModel.assegnatarioSelezionato = undefined;
            self.supportModel.dataDa = undefined;
            self.supportModel.dataA = undefined;
            self.supportModel.confirmEnabled = false;
        }
    }
})